import { HeaderPc } from './Header/Header.pc';
import { HeaderMobile } from './Header/Header.mobile';
import { useIsMobile } from '../../hook/useIsMobile';

export const Header = () => {
  const isMobile = useIsMobile();
  return isMobile ? <HeaderMobile /> : <HeaderPc />;
};
